export var DrilldownSubject;
(function (DrilldownSubject) {
    DrilldownSubject["drilldownSettingsPage"] = "drilldown-settings-page";
    DrilldownSubject["tableAddButton"] = "table-add-button";
    DrilldownSubject["saveDrilldownButton"] = "save-drilldown-button";
    DrilldownSubject["tableEmptyState"] = "table-empty-state";
    DrilldownSubject["createDrilldown"] = "create-drilldown";
})(DrilldownSubject || (DrilldownSubject = {}));
//# sourceMappingURL=drilldowns.enum.js.map